import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, unref as _unref, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/image/btn.png';
import _imports_1 from '@/assets/image/helpCenter/qaRobot.png';
import _imports_2 from '../../assets/image/avatar.png';
const _withScopeId = n => (_pushScopeId("data-v-81ed4ae2"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "layout-container"
};
const _hoisted_2 = {
  class: "logo"
};
const _hoisted_3 = ["src"];
const _hoisted_4 = {
  key: 1
};
const _hoisted_5 = {
  class: "info_wrap"
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: ""
}, null, -1));
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "帮助中心", -1));
const _hoisted_8 = [_hoisted_6, _hoisted_7];
const _hoisted_9 = {
  class: "user-info"
};
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "avatar"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  alt: ""
})], -1));
const _hoisted_11 = {
  class: "name"
};
const _hoisted_12 = {
  class: "username"
};
const _hoisted_13 = {
  key: 0,
  class: "account-name"
};
const _hoisted_14 = {
  class: "login-entrance"
};
const _hoisted_15 = {
  class: "account-input"
};
const _hoisted_16 = {
  class: "dialog-footer"
};
const _hoisted_17 = {
  key: 0,
  class: "invite-code"
};
const _hoisted_18 = {
  class: "code-list"
};
const _hoisted_19 = {
  class: "copy-link"
};
const _hoisted_20 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "line"
}, "|", -1));
const _hoisted_21 = {
  class: "the-countdown"
};
const _hoisted_22 = {
  key: 0
};
const _hoisted_23 = {
  key: 1
};
const _hoisted_24 = ["src"];
import { computed, reactive, ref, watch, getCurrentInstance, onBeforeMount, onMounted, provide, readonly } from 'vue';
import { useStore } from 'vuex';
import { useRoute, useRouter } from 'vue-router';
import { getStationInfo, tokenValidate, requestResetPwd, requestResetPwdSendCode, getChannelBackgroundName } from '@/assets/api/login.js';
import { integrationLogout, integrationChangePassword } from '@/assets/api/integrationLogin';
import { helpCenterWindow } from '@/assets/api/helpCenterMenu/helpCenter.js';
import { getMessageUnreadCount } from '@/assets/api/helpCenterMenu/helpCenter.js';
import { UserFilled, ArrowDown } from '@element-plus/icons-vue';
import { getSiteNoticeIsRead } from '@/assets/api/siteNotice';
import { ElMessage } from 'element-plus';
import Sidebar from './comp/sidebar.vue';
import { copyAction, countdown } from '@/assets/js/utils';
import { requestGenerateInviteCode, requestInviteCode } from '@/assets/api/userManagement';
import moment from 'moment/moment';
import Guide from './comp/guide.vue';
import systemMessageDialog from './comp/systemMessageDialog.vue';
import packageComponent from './comp/packageComponent.vue';
import personalAccountRenewal from './personalAccountRenewal/personalAccountRenewal.vue';
import IDialog from '@/components/IDialog.vue';
import { filterLoginPath } from '@/utils/filterLoginPath.js';
import b1 from '@/assets/image/swiper/1.jpg';
import b2 from '@/assets/image/swiper/2.jpg';
import b3 from '@/assets/image/swiper/3.jpg';
import b4 from '@/assets/image/swiper/4.jpg';
import b5 from '@/assets/image/swiper/5.jpg';
import b6 from '@/assets/image/swiper/6.jpg';
import b7 from '@/assets/image/swiper/7.jpg';
import { filterHost } from '@/utils/filterHost.js';
// ********************(基本参数)********************

export default {
  __name: 'layout',
  setup(__props) {
    const $route = useRoute();
    const $router = useRouter();
    const $store = useStore();

    // 侧边栏菜单实例
    const sidebarRef = ref(null);
    const dialogRef = ref(null);
    const bannerList = [b1, b2, b3, b4, b5, b6, b7];
    // 提供侧边栏实例给下级组件使用
    provide('sidebarRef', readonly(sidebarRef));
    // 修改密码表单
    const changePasswordForm = ref({
      oldPassword: '',
      newPassword: '',
      confirmNewPassword: ''
    });
    const checkIsLogin = () => {
      return localStorage.getItem('wp_ct-channel-token') || localStorage.getItem('integration_loginSuccess');
    };

    // 获取当前实例
    const {
      proxy: ctx
    } = getCurrentInstance();

    // 控制展开和收缩
    const opened = ref(true);
    // 操作展开
    const handleExpend = () => {
      opened.value = !opened.value;
    };
    // 获取站点信息 这里获取站点信息是为了统一登录路口没有调获取站点信息
    // const setStationInfo = async () => {
    //   const result = await getStationInfo()
    //   if (result.code == 200) {
    //     const data = result.data
    //     localStorage.setItem('qdStationInfo', JSON.stringify(data))
    //     $store.commit('setStationInfo', data)
    //   }
    // }
    // setStationInfo()
    const qdStationInfo = JSON.parse(localStorage.getItem('qdStationInfo'));

    // ********************(渠道后台名称)********************
    // 名称类型
    const titleType = ref(1);
    // 名称图片
    const titleImgUrl = ref('');
    // 名称
    const titleText = ref('');
    // 获取渠道后台名称
    async function getChannelBackgroundNameHandler() {
      const result = await getChannelBackgroundName();
      // console.log('getChannelBackgroundName', result)
      if (result.code == 200) {
        const data = result.data;
        // 1：图片，2：文字
        titleType.value = data.title_type;
        titleImgUrl.value = data.img_url;
        titleText.value = data.title_text;
      } else {
        // ElMessage.error(result.message)
      }
    }
    getChannelBackgroundNameHandler();

    // ********************（检测token状态）********************
    // 检测token是否过期
    const authentication = async () => {
      const channelToken = localStorage.getItem('wp_ct-channel-token');
      // 不存在渠道token，不做校验，直接前往登录页面
      if (!checkIsLogin()) {
        logout();
        return;
      }
      const result = await tokenValidate({
        partner_code: $route.query.partner_code,
        ct_channel_token: channelToken
      });
      // console.log('authentication', result)
      if (result.code == 200) {
        const data = result.data;
        if (data) {
          var _$store$state$userInf;
          // 检测的渠道id
          const channelId = data.channelid;
          // 当前存贮的渠道id
          const storeChannelId = (_$store$state$userInf = $store.state.userInfo) === null || _$store$state$userInf === void 0 ? void 0 : _$store$state$userInf.channelid;
          // console.log(channelId, storeChannelId)
          if (channelId != storeChannelId) {
            // 不相同的话，将本地存贮的用户信息设入
            let localUserInfo = '';
            try {
              const localUserInfoStr = localStorage.getItem('wp_userInfo');
              localUserInfo = typeof localUserInfoStr === 'string' ? JSON.parse(localUserInfoStr) : localUserInfoStr;
            } catch (e) {
              console.log(e);
            }
            if (localUserInfo) {
              console.log('localUserInfo');
              $store.commit('setUserInfo', localUserInfo);
            }
          }
        }
      } else {
        ElMessage.error({
          message: result.message,
          grouping: true
        });
        logout();
      }
    };
    const setUserInfo = () => {
      const localUserInfoStr = localStorage.getItem('wp_userInfo');
      const localUserInfo = typeof localUserInfoStr === 'string' ? JSON.parse(localUserInfoStr) : localUserInfoStr;
      if (localUserInfo) {
        $store.commit('setUserInfo', localUserInfo);
      }
    };
    setUserInfo();
    // 如果本地存在token则调用校验token令牌的接口
    // if (checkIsLogin()) {
    //   authentication()
    // } else {
    //   $router.push('/login')
    // }

    // ********************（退出登录）********************
    // 下拉菜单事件
    const commandEvent = sign => {
      switch (sign) {
        case 'logout':
          logout();
          break;
        case 'openResetPwd':
          resetDialog.value = true;
          break;
      }
    };
    // 退出登录
    const logout = async () => {
      await integrationLogout({});
      // 清理信息，退出登录
      localStorage.removeItem('wp_ct-channel-token');
      localStorage.removeItem('wp_userInfo');
      localStorage.removeItem('miniProgramUpdateTipFlag');
      // 移出渠道账户一体化的token
      localStorage.removeItem('integration_channel_user_token');
      localStorage.removeItem('channel-background-token');
      // localStorage.removeItem('integration_loginSuccess')
      localStorage.removeItem('wp_loginSuccess');
      localStorage.removeItem('wp_partner_code');
      localStorage.removeItem('qdStationInfo');
      $store.commit('setUserInfo', '');
      console.log('是否为渠道账户一体化', filterHost());
      // 是不是渠道账户一体化的退出登录
      if (filterHost()) {
        window.location.href = filterLoginPath();
      } else {
        $router.push('/login');
      }
    };

    // ********************（用户信息）********************
    // 用户名
    const username = computed(() => {
      var _$store$state$userInf2;
      return (_$store$state$userInf2 = $store.state.userInfo) === null || _$store$state$userInf2 === void 0 ? void 0 : _$store$state$userInf2.user_name;
    });
    // 用户名二号
    const accountName = computed(() => {
      var _$store$state$userInf3;
      return (_$store$state$userInf3 = $store.state.userInfo) === null || _$store$state$userInf3 === void 0 ? void 0 : _$store$state$userInf3.account_name;
    });

    // ********************(消息通知未读状态)********************
    // 获取未读信息
    async function getMessageUnreadCountHandler() {
      const result = await getMessageUnreadCount();
      // console.log('getMessageUnreadCountHandler', result)
      if (result.code == 200) {
        const data = result.data;
        $store.commit('helpCenter/setMessageNotificationUnreadStatus', Object.values(data).some(item => item > 0));
      } else {
        ElMessage.error(result.message);
      }
    }
    // 统合消息未读状态（消息通知和网站维护通知，又一个未读，则综合通知状态设置为未读）
    const messageComprehensiveUnreadStatus = computed(() => $store.getters['helpCenter/messageComprehensiveUnreadStatus']);

    // ********************（站点通知详情）********************
    // 渠道查询是否有未读消息
    // true 有未读， false 无未读
    // 方向理解为【true 存在未读 显示红点】【false 全部已读 不显示红点】
    const siteNoticeIsRead = computed(() => $store._state.data.siteNoticeIsRead);
    // 获取通知公告、是否全部已读
    const handleGetSiteNotice = async () => {
      var _data$data;
      const data = await getSiteNoticeIsRead();
      if (data.code != 200) return;
      $store.commit('setSiteNoticeStatus', data === null || data === void 0 ? void 0 : (_data$data = data.data) === null || _data$data === void 0 ? void 0 : _data$data.latest);
    };
    // 监听路由变化
    watch(() => $router.currentRoute.value.name, value => {
      // 当进入这两个路由时，才调用看看是不是全部已读，其他地方就不调用了
      if (['processWatch', 'siteNoticeDetail'].includes(value)) {
        getMessageUnreadCountHandler();
        handleGetSiteNotice();
      }
    }, {
      immediate: true
    });
    // 跳转到通知详情
    const handleNoticeDetail = () => {
      // $router.push({ name: 'siteNoticeDetail' })
      $router.push({
        name: 'messageNotification'
      });
    };
    // 判断一下，这个页面需不需要默认的padding 30 px
    // 包含在数组里面的表示，不需要
    const filterCommonPadding = () => {
      return !['/siteNoticeDetail'].includes($route.path);
    };

    // 修改密码的弹窗
    const resetDialog = ref(false);
    // 表单验证
    const rules = {
      oldPassword: [{
        required: true,
        message: '请输入您的旧密码',
        trigger: 'blur'
      }],
      newPassword: [{
        required: true,
        message: '请输入您的新密码',
        trigger: 'blur'
      }],
      confirmNewPassword: [{
        required: true,
        message: '请输入您的确认密码',
        trigger: 'blur'
      }]
    };
    const close = () => {
      vcBtnDisabled.value = true;
      forgotForm.value.resetFields();
    };
    // 忘记密码表单的ref
    const forgotForm = ref(null);
    // 忘记密码表单
    const forgotInfo = reactive({
      mobile: '',
      short_message: '',
      pwd: ''
    });
    // 获取验证码节流信息
    const vcFgWaitInfo = ref({
      text: '',
      status: false
    });
    // 验证码按钮状态
    const vcBtnDisabled = ref(true);
    // 修改密码按钮的禁用状态
    const forgotBtnDisabled = computed(() => {
      const {
        mobile,
        short_message,
        pwd
      } = forgotInfo;
      /*
       手机号位11位
      */
      const mobileStatus = (mobile === null || mobile === void 0 ? void 0 : mobile.length) == 11;
      /*
       验证码位6位
      */
      const shortMessageStatus = (short_message === null || short_message === void 0 ? void 0 : short_message.length) == 6;
      /*
        密码为8-16位
      */
      const pwdStatus = (pwd === null || pwd === void 0 ? void 0 : pwd.length) >= 6 && (pwd === null || pwd === void 0 ? void 0 : pwd.length) <= 20;
      /*
        判断手机号验证码密码是否符合规则，符合关闭重置密码按钮的禁用状态，反之则打开
      */
      return !(mobileStatus && shortMessageStatus && pwdStatus);
    });
    // 按钮loading
    const loading = ref(false);
    // 手机号输入事件
    const mobileInput = mobileValue => {
      vcBtnDisabled.value = mobileValue.length == 11 ? false : true;
    };
    // 获取验证码
    const getFgVerificationCode = async () => {
      const result = await requestResetPwdSendCode({
        mobile: forgotInfo.mobile
      });
      if (result.code == 200) {
        // 60秒等待
        countdown('forgotPwd', vcFgWaitInfo);
        const data = result.data;
        if (data) {
          // 测试环境，直接设入验证码
          forgotInfo.short_message = data.message;
          // 手动触发按钮状态修改
          // $nextTick(() => {
          //   forgotForm.value.validateField('short_message')
          // })
        }
      } else {
        ctx.$message({
          message: result.message || '操作失败',
          type: 'error',
          duration: 3000,
          'show-close': true,
          grouping: true
        });
      }
    };
    // 确认修改密码
    const handleConfirmUpdatePwd = () => {
      if (!forgotForm.value || !forgotForm.value.validate) return;
      forgotForm.value.validate((valid, fields) => {
        if (valid) {
          resetPwdEvent();
        } else {
          // 第一条错误信息
          const firstErrorMessage = Object.values(fields)[0][0].message || '输入验证失败';
          ctx.$message({
            message: firstErrorMessage,
            type: 'error',
            duration: 3000,
            'show-close': true,
            grouping: true
          });
        }
      });
    };
    const handleIntegrationChangePassword = async () => {
      forgotForm.value.validate(async (valid, fields) => {
        var _JSON$parse, _JSON$parse$principal;
        if (!valid) return;
        if (changePasswordForm.value.newPassword !== changePasswordForm.value.confirmNewPassword) {
          return ElMessage.error('两次密码输入不一致');
        }
        const currentUserID = $store.state.userInfo.userid || ((_JSON$parse = JSON.parse(localStorage.getItem('integrationUserInfo'))) === null || _JSON$parse === void 0 ? void 0 : (_JSON$parse$principal = _JSON$parse.principal) === null || _JSON$parse$principal === void 0 ? void 0 : _JSON$parse$principal.userId);
        // changePasswordForm
        const result = await integrationChangePassword({
          ...changePasswordForm.value,
          userId: currentUserID
        });
        if (result.code != 200) return ElMessage.error(result.message);
        ElMessage.success('密码修改成功');
        logout();
      });
    };
    // 重置密码事件
    const resetPwdEvent = async () => {
      loading.value = true;
      const result = await requestResetPwd(forgotInfo);
      const {
        code,
        message
      } = result;
      loading.value = false;
      if (code !== 200) {
        ctx.$message.error(message);
        return;
      }
      ctx.$message.success('修改成功');
      $router.push('/login');
    };

    /* -----------------邀请码逻辑------------------------  */
    // 邀请码定时器id
    let timerId = null;
    // 定义一个变量判断邀请码是否过期
    const isOverdue = ref(false);
    // 生成邀请码的加载loading
    const inviteCodeLoading = ref(false);
    // 邀请码信息
    const inviteCodeInfo = reactive({
      invite_code: '0000',
      code_failure_time: ''
    });
    // 获取邀请码
    const getInviteCode = async () => {
      const res = await requestInviteCode();
      const {
        code,
        message,
        data
      } = res;
      if (code !== 200) {
        // return ElMessage.error(message)
      }
      inviteCodeInfo.invite_code = data !== null && data !== void 0 && data.invite_code ? `${data === null || data === void 0 ? void 0 : data.invite_code}` : '----';
      inviteCodeInfo.code_failure_time = data.code_failure_time;
      clearInterval(timerId);
      inviteCodeCountDown(data.code_failure_time);
    };
    // 生成邀请码
    const generateInviteCode = async () => {
      // 取缓存方便调试
      const count = localStorage.getItem('count');
      let code_failure_time;
      if (count) {
        code_failure_time = moment(Date.now() + parseInt(count)).format('yyyy-MM-DD HH:mm:ss');
      } else {
        code_failure_time = moment(Date.now() + 2 * 60 * 60 * 1000).format('yyyy-MM-DD HH:mm:ss');
      }
      inviteCodeLoading.value = true;
      const res = await requestGenerateInviteCode({
        code_failure_time
      });
      const {
        code,
        data,
        message
      } = res;
      inviteCodeLoading.value = false;
      if (code !== 200) {
        return ElMessage.error(message);
      }
      inviteCodeInfo.invite_code = data !== null && data !== void 0 && data.invite_code ? `${data === null || data === void 0 ? void 0 : data.invite_code}` : '----';
      inviteCodeInfo.code_failure_time = data.code_failure_time;
      clearInterval(timerId);
      inviteCodeCountDown(data.code_failure_time);
    };
    // 失效时间倒计时文本
    const countDownText = ref('');
    // 邀请码生效时间倒计时
    const inviteCodeCountDown = endTime => {
      // 初始化状态，从未申请邀请码
      if (!endTime) {
        isOverdue.value = true;
        countDownText.value = '请点击按钮生成邀请码!';
        return;
      }
      const start = Date.now();
      const end = moment(endTime).valueOf();
      let timeDifference = Math.floor((end - start) / 1000);
      if (timeDifference <= 0) {
        isOverdue.value = true;
        countDownText.value = '邀请码已过期, 请重新生成!';
        return;
      }
      isOverdue.value = false;
      countDownText.value = formatCountDown(timeDifference);
      timerId = setInterval(() => {
        timeDifference--;
        if (timeDifference <= 0) {
          clearInterval(timerId);
          isOverdue.value = true;
          countDownText.value = '邀请码已过期, 请重新生成!';
        } else {
          countDownText.value = formatCountDown(timeDifference);
        }
      }, 1000);
    };
    // 对倒计时时间进行格式化
    const formatCountDown = timeDifference => {
      let h = parseInt(`${timeDifference / 60 / 60}`);
      let m = parseInt(`${timeDifference / 60 % 60}`);
      let s = parseInt(`${timeDifference % 60}`);
      h = h < 10 ? `0${h}` : h;
      m = m < 10 ? `0${m}` : m;
      s = s < 10 ? `0${s}` : s;
      return countDownText.value = `${h}:${m}:${s}`;
    };
    // 复制邀请码
    const copyInviteCode = () => {
      copyAction(inviteCodeInfo.invite_code);
      ElMessage.success('复制成功');
    };
    onBeforeMount(() => {
      countdown('forgotPwd', vcFgWaitInfo, false);
      getInviteCode();
    });

    // ********************(帮助中心)********************
    // 是否拥有后台帮助中心权限
    const helpCenterPermission_back = computed(() => $store.getters['helpCenter/helpCenterPermission_back']);
    // 是否拥有消息通知权限
    const messagePermission_back = computed(() => $store.getters['helpCenter/messagePermission_back']);
    // 打开帮助中心
    function openHelpCenter() {
      $router.push('/helpCenter');
    }
    const systemMessageDialogRef = ref();
    onMounted(() => {
      // 拥有后台帮助中心权限
      watch(messagePermission_back, async () => {
        if (messagePermission_back.value) {
          systemMessageDialogRef.value.showDialog();
        }
      }, {
        immediate: true
      });
    });
    return (_ctx, _cache) => {
      const _component_el_aside = _resolveComponent("el-aside");
      const _component_Bell = _resolveComponent("Bell");
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_el_badge = _resolveComponent("el-badge");
      const _component_el_dropdown_item = _resolveComponent("el-dropdown-item");
      const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu");
      const _component_el_dropdown = _resolveComponent("el-dropdown");
      const _component_el_header = _resolveComponent("el-header");
      const _component_router_view = _resolveComponent("router-view");
      const _component_el_scrollbar = _resolveComponent("el-scrollbar");
      const _component_el_main = _resolveComponent("el-main");
      const _component_el_container = _resolveComponent("el-container");
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_dialog = _resolveComponent("el-dialog");
      const _component_el_carousel_item = _resolveComponent("el-carousel-item");
      const _component_el_carousel = _resolveComponent("el-carousel");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_container, null, {
        default: _withCtx(() => [_createVNode(_component_el_aside, {
          width: "250px"
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [titleType.value == 1 && titleImgUrl.value ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            src: titleImgUrl.value,
            alt: ""
          }, null, 8, _hoisted_3)) : _createCommentVNode("", true), titleType.value == 2 ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(titleText.value), 1)) : _createCommentVNode("", true)]), _createVNode(Sidebar, {
            ref_key: "sidebarRef",
            ref: sidebarRef,
            opened: opened.value
          }, null, 8, ["opened"])]),
          _: 1
        }), _createVNode(_component_el_container, null, {
          default: _withCtx(() => [_createVNode(_component_el_header, null, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_5, [_createElementVNode("img", {
              class: "btn-icon",
              src: _imports_0,
              onClick: _cache[0] || (_cache[0] = $event => dialogRef.value.changeDialogVisible(true))
            }), _unref(helpCenterPermission_back) ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "help-center",
              onClick: openHelpCenter
            }, _hoisted_8)) : _createCommentVNode("", true), _unref(messagePermission_back) ? (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: "site_notice_wrap",
              onClick: handleNoticeDetail
            }, [_createVNode(_component_el_badge, {
              "is-dot": _unref(messageComprehensiveUnreadStatus),
              class: "item"
            }, {
              default: _withCtx(() => [_createVNode(_component_el_icon, null, {
                default: _withCtx(() => [_createVNode(_component_Bell)]),
                _: 1
              })]),
              _: 1
            }, 8, ["is-dot"])])) : _createCommentVNode("", true), _createVNode(packageComponent), _createVNode(_component_el_dropdown, {
              trigger: "click",
              onCommand: commandEvent
            }, {
              dropdown: _withCtx(() => [_createVNode(_component_el_dropdown_menu, null, {
                default: _withCtx(() => [_createVNode(_component_el_dropdown_item, {
                  command: "openResetPwd"
                }, {
                  default: _withCtx(() => [_createTextVNode("修改密码")]),
                  _: 1
                }), _createVNode(_component_el_dropdown_item, {
                  command: "logout"
                }, {
                  default: _withCtx(() => [_createTextVNode("退出登录")]),
                  _: 1
                })]),
                _: 1
              })]),
              default: _withCtx(() => [_createElementVNode("div", _hoisted_9, [_hoisted_10, _createElementVNode("div", _hoisted_11, [_createElementVNode("p", _hoisted_12, _toDisplayString(_unref(username)), 1), _unref(accountName) ? (_openBlock(), _createElementBlock("p", _hoisted_13, _toDisplayString(_unref(accountName)), 1)) : _createCommentVNode("", true)]), _createVNode(_component_el_icon, {
                class: "el-icon--right"
              }, {
                default: _withCtx(() => [_createVNode(_unref(ArrowDown))]),
                _: 1
              })])]),
              _: 1
            })])]),
            _: 1
          }), _createVNode(_component_el_main, null, {
            default: _withCtx(() => [_createVNode(_component_el_scrollbar, null, {
              default: _withCtx(() => [_createElementVNode("div", {
                class: _normalizeClass({
                  'inline-page': filterCommonPadding()
                })
              }, [_createVNode(_component_router_view)], 2)]),
              _: 1
            })]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      }), _createVNode(_component_el_dialog, {
        modelValue: resetDialog.value,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => resetDialog.value = $event),
        title: "修改密码",
        onClose: close,
        "custom-class": "report-dialog"
      }, {
        footer: _withCtx(() => [_createElementVNode("span", _hoisted_16, [_createVNode(_component_el_button, {
          onClick: _cache[4] || (_cache[4] = $event => resetDialog.value = false)
        }, {
          default: _withCtx(() => [_createTextVNode("取消")]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          onClick: handleIntegrationChangePassword
        }, {
          default: _withCtx(() => [_createTextVNode("确定")]),
          _: 1
        })])]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_14, [_createElementVNode("div", _hoisted_15, [_createVNode(_component_el_form, {
          model: changePasswordForm.value,
          class: "forgot",
          rules: rules,
          ref_key: "forgotForm",
          ref: forgotForm,
          "label-width": "80px"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "原密码",
            prop: "oldPassword"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: changePasswordForm.value.oldPassword,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => changePasswordForm.value.oldPassword = $event),
              maxlength: "20",
              minlength: "6",
              placeholder: "请输入您的原密码",
              type: "text"
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "新密码",
            prop: "newPassword"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: changePasswordForm.value.newPassword,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => changePasswordForm.value.newPassword = $event),
              maxlength: "20",
              minlength: "6",
              placeholder: "请输入您的新密码",
              type: "password",
              "show-password": ""
            }, null, 8, ["modelValue"])]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "确认密码",
            prop: "confirmNewPassword"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_input, {
              modelValue: changePasswordForm.value.confirmNewPassword,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => changePasswordForm.value.confirmNewPassword = $event),
              maxlength: "20",
              minlength: "6",
              placeholder: "请输入您的确认密码",
              type: "password",
              "show-password": ""
            }, null, 8, ["modelValue"])]),
            _: 1
          })]),
          _: 1
        }, 8, ["model"])])])]),
        _: 1
      }, 8, ["modelValue"]), _unref($store).getters.generateInvitationCode ? (_openBlock(), _createElementBlock("div", _hoisted_17, [_createVNode(_component_el_button, {
        type: "primary",
        loading: inviteCodeLoading.value,
        onClick: generateInviteCode
      }, {
        default: _withCtx(() => [_createTextVNode("生成邀请码")]),
        _: 1
      }, 8, ["loading"]), _createElementVNode("ul", _hoisted_18, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(inviteCodeInfo === null || inviteCodeInfo === void 0 ? void 0 : inviteCodeInfo.invite_code, (code, index) => {
        return _openBlock(), _createElementBlock("li", {
          class: "code-item",
          key: index
        }, _toDisplayString(code), 1);
      }), 128))]), _createElementVNode("div", _hoisted_19, [_createVNode(_component_el_button, {
        type: "text",
        onClick: copyInviteCode
      }, {
        default: _withCtx(() => [_createTextVNode("复制")]),
        _: 1
      })]), _hoisted_20, _createElementVNode("div", _hoisted_21, [!isOverdue.value ? (_openBlock(), _createElementBlock("span", _hoisted_22, "邀请码距离失效还有 " + _toDisplayString(countDownText.value), 1)) : (_openBlock(), _createElementBlock("span", _hoisted_23, _toDisplayString(countDownText.value), 1))])])) : _createCommentVNode("", true), _createVNode(Guide), _createVNode(systemMessageDialog, {
        ref_key: "systemMessageDialogRef",
        ref: systemMessageDialogRef
      }, null, 512), _createVNode(personalAccountRenewal, {
        ref: "personalAccountRenewalRef"
      }, null, 512), _createVNode(IDialog, {
        class: "swiper-dialog",
        ref_key: "dialogRef",
        ref: dialogRef,
        isShowBtns: false,
        showClose: false,
        width: "800px",
        "destroy-on-close": false
      }, {
        content: _withCtx(() => [_createVNode(_component_el_carousel, {
          height: "680px"
        }, {
          default: _withCtx(() => [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(bannerList, item => {
            return _createVNode(_component_el_carousel_item, {
              key: item
            }, {
              default: _withCtx(() => [_createElementVNode("img", {
                style: {
                  "width": "800px"
                },
                src: item,
                alt: ""
              }, null, 8, _hoisted_24)]),
              _: 2
            }, 1024);
          }), 64))]),
          _: 1
        })]),
        _: 1
      }, 512)]);
    };
  }
};